import React from 'react'

import { ChargePointSchedulesPage } from '../../../ui/ChargePointSchedulesPage'

export const UserAppSchedulePage = (): React.ReactElement => (
    <div className="page-layout-container">
        <ChargePointSchedulesPage />
    </div>
)
